import { __awaiter } from '../../_virtual/_tslib.js';
import { getGlobalSupport, defalutSpmId, deepMerge, checkRate } from '../utils/unils.js';
import { isInBrowser } from '../utils/isInBrowser.js';
import { SDK_VERSION } from '../common/config.js';
import { useKv } from '@bilibili/cross-scripts';

const _support = getGlobalSupport();
// 白名单默认配置
const defaultWhiteListConfig = {
    SPMID: '333.1333',
    GROUP: 'bilimirror',
    KEY: 'whitelist',
    KEYTOP: 'toplist'
};
class Options {
    constructor() {
        this.origin = 'bili'; // 上报业务所属
        this.module = 'common'; // 具体业务名称
        this.config = {};
        this.kvOptions = {};
        // 默认兜底配置,kv拉取失败时使用
        this._defaultKvConfig = {
            performance: 1,
            poll: 5,
            techpv: 5,
            userLog: [],
            resourceTime: {},
            userLogDeep: 10,
            track: {},
            filterEndJs: false
        };
    }
    // 拉取kv
    fetchWhiteListConfig(configSDKIns, getKey, isDefault = false) {
        return new Promise((resolve, reject) => {
            configSDKIns
                .get(getKey)
                .then(res => {
                if (!res) {
                    if (!isDefault) {
                        console.warn(`${configSDKIns.storage.appKey}-没有对应配置,返回默认配置`);
                    }
                    resolve(isDefault ? this._defaultKvConfig : {});
                    return;
                }
                const config = JSON.parse(res);
                resolve(config);
            })
                .catch(err => {
                console.warn(`${configSDKIns.storage.appKey},mirror获取白名单配置失败,返回默认配置`);
                resolve(this._defaultKvConfig);
            });
        });
    }
    // KV下发白名单配置
    getConfig() {
        return __awaiter(this, void 0, void 0, function* () {
            // 默认拉取333.1333kv配置信息
            this._defaultConfigSDK = yield useKv(Object.assign({ appKey: defaultWhiteListConfig.SPMID, strict: 1, reporter: {
                    ignoreAppKeyNotFound: true
                } }, this.kvOptions));
            const { SPMID, GROUP, KEY, KEYTOP } = defaultWhiteListConfig;
            const spmId = this.spmId || defalutSpmId;
            const baseConfig = yield this.fetchWhiteListConfig(this._defaultConfigSDK, `${GROUP}.${KEY}`, true);
            const topConfig = yield this.fetchWhiteListConfig(this._defaultConfigSDK, `${GROUP}.${KEYTOP}`, true);
            let pageConfig = {};
            if (SPMID !== spmId) {
                // 页面id不是默认的333.1333，再拉取一次页面id的kv配置
                if (this._configSDK) {
                    delete this._configSDK;
                }
                this._configSDK = yield useKv(Object.assign({ appKey: spmId, strict: 1, reporter: {
                        ignoreAppKeyNotFound: true
                    } }, this.kvOptions));
                pageConfig = yield this.fetchWhiteListConfig(this._configSDK, `${GROUP}.${KEY}`);
            }
            // 合并配置
            let config = deepMerge(baseConfig, pageConfig);
            // 合并顶层配置
            config = deepMerge(config, topConfig);
            // 这里的config待优化的点
            return new Promise(resolve => {
                // 错误白名单
                this.config['white'] = (config === null || config === void 0 ? void 0 : config.white) || {};
                // 性能采样率
                this.config['white-performance-rate'] = config.performance ? checkRate(config === null || config === void 0 ? void 0 : config.performance) : 1;
                // 聚合上报时间（1-10）分钟限制
                this.config['poll-time'] = config.poll ? checkRate(config === null || config === void 0 ? void 0 : config.poll) : 5;
                // 技术pv上报配置（1-10)
                this.config['tech-pv'] = config.techpv ? checkRate(config === null || config === void 0 ? void 0 : config.techpv) : 5;
                // 用户行为日志配置
                this.config['user-log'] = (config === null || config === void 0 ? void 0 : config.userLog) || [];
                // 资源加载监听列表
                this.config['resource-time'] = (config === null || config === void 0 ? void 0 : config.resourceTime) || {};
                // 用户行为日志堆栈深度
                this.config['user-log-deep'] = (config === null || config === void 0 ? void 0 : config.userLogDeep) || 10;
                // 离线追踪日志开启白名单配置
                this.config['track'] = (config === null || config === void 0 ? void 0 : config.track) || {};
                // fileName不是.js结尾的不进行上报
                this.config['filter-end-js'] = (config === null || config === void 0 ? void 0 : config.filterEndjs) || false;
                // 播放器日志上报js
                this.config['player-log-umd'] = (config === null || config === void 0 ? void 0 : config.playLogUmd) || '';
                // track灰度比例
                this.config['track-gray'] = (config === null || config === void 0 ? void 0 : config.trackGrayV2) || 0;
                resolve();
            });
        });
    }
    bindOptions(Options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            // 注入window版本号
            _support.mirrorVersion = SDK_VERSION;
            Object.keys(Options).forEach(item => {
                // config配置只有白屏检测，不需要同步
                if (item === 'config')
                    return;
                // module有可能是方法
                if (item === 'module' && typeof Options[item] === 'function') {
                    this[item] = Options[item]();
                }
                else {
                    this[item] = Options[item];
                }
            });
            // 白名单处理
            yield this.getConfig();
            return Promise.resolve('ok');
        });
    }
    updateModule(val) {
        this.module = val;
    }
}
function getBrowserOptions() {
    return _support.options || (_support.options = new Options());
}
const options = isInBrowser() ? getBrowserOptions() : null;
function initOptions(paramOptions = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        if (isInBrowser()) {
            const res = yield options.bindOptions(paramOptions);
            return res;
        }
    });
}
function changeModule(value) {
    const ins = getBrowserOptions();
    ins === null || ins === void 0 ? void 0 : ins.updateModule(value);
}

export { changeModule, initOptions, options };
